var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-container"},[_c('b-button',{staticClass:"button",attrs:{"href":_vm.href}},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.icon)?_c('i',{class:`bi bi-${_vm.icon} icon`}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }